<template>
  <div>
    <progress-loader ref="progress"></progress-loader>
    <v-server-table
      id="list-table"
      :url="url"
      :columns="columns"
      :options="options"
      @loading="onTableLoading"
      @loaded="onTableLoaded"
      @pagination="onPagination"
      ref="dataTable">

      <template slot="actionButtons" slot-scope="props">
        <div class="nowrap">
          <b-button size="sm" class="btn-rounded" variant="info" :href="getUrlDetail(props.row.uuid)" title="Details"><i class="fa fa-info text-white"/></b-button>
          <b-button size="sm" class="btn-rounded" variant="primary" :href="getUrlDetail(props.row.uuid) + '/edit'" title="Edit"><i class="fa fa-pencil"/></b-button>
          <b-button size="sm" class="btn-rounded" variant="danger" @click="doRemove(props.row.uuid)" title="Remove"><i class="fa fa-times"/></b-button>
        </div>
      </template>
      
      <template slot="securityCheckSeriesSchedule" slot-scope="props">
        <div class="nowrap text-center">
          {{props.row.securityCheckSeriesSchedule === null ? '-' : props.row.securityCheckSeriesSchedule}}
        </div>
      </template>

      <template slot="billingDetailButton" slot-scope="props">
        <div class="nowrap">
          <b-button size="sm" class="btn-rounded" variant="info" :href="'/#/billing/' + props.row.uuid" title="Details"><i class="fa fa-info text-white"/></b-button>
        </div>
      </template>

      <template slot="actionButtonLocationGroup" slot-scope="props">
        <div class="nowrap">
          <b-button size="sm" class="btn-rounded" variant="primary" :href="getUrlDetail(props.row.uuid) + '/edit'" title="Edit"><i class="fa fa-pencil"/></b-button>
          <b-button size="sm" class="btn-rounded" variant="danger" @click="doRemove(props.row.uuid)" title="Remove"><i class="fa fa-times"/></b-button>
        </div>
      </template>

      <template slot="actionButtons2" slot-scope="props">
        <div class="nowrap">
          <b-button size="sm" class="btn-rounded" variant="info" :href="getUrlDetail(props.row.uuid)" title="Details"><i class="fa fa-info text-white"/></b-button>
          <b-button size="sm" class="btn-rounded" variant="danger" @click="doRemove(props.row.uuid)" title="Remove"><i class="fa fa-times"/></b-button>
        </div>
      </template>

      <template slot="locationSecurityChecking" slot-scope="props">
        <div class="nowrap">
          <a :href="'/#/settings/locations/' + props.row.location.uuid" title="Details">{{props.row.location.name}}</a>
        </div>
      </template>

      <template slot="actionButtons3" slot-scope="props">
        <div class="nowrap">
          <!-- <b-btn size="sm" class="btn-rounded" variant="info" v-on:click="doOpenRowDetail(props.row.uuid)" title="Details"><i class="fa fa-info text-white"/></b-btn> -->
          <b-button size="sm" class="btn-rounded" variant="info" :href="getUrlDetail(props.row.uuid)" title="Details"><i class="fa fa-info text-white"/></b-button>
        </div>
      </template>

      <template slot="actionButtonsVisitorTenant3" slot-scope="props">
        <div class="nowrap">
          <!-- <b-btn size="sm" class="btn-rounded" variant="info" v-on:click="doOpenRowDetail(props.row.uuid)" title="Details"><i class="fa fa-info text-white"/></b-btn> -->
          <b-button size="sm" class="btn-rounded" variant="info" :href="'/#/visitor/'+props.row.uuid" title="Details"><i class="fa fa-info text-white"/></b-button>
        </div>
      </template>

      <template slot="actionButtonsComplaintTenant3" slot-scope="props">
        <div class="nowrap">
          <!-- <b-btn size="sm" class="btn-rounded" variant="info" v-on:click="doOpenRowDetail(props.row.uuid)" title="Details"><i class="fa fa-info text-white"/></b-btn> -->
          <b-button size="sm" class="btn-rounded" variant="info" :href="'/#/complaint/'+props.row.uuid" title="Details"><i class="fa fa-info text-white"/></b-button>
        </div>
      </template>

      <template slot="actionButtonsRequestTenant3" slot-scope="props">
        <div class="nowrap">
          <!-- <b-btn size="sm" class="btn-rounded" variant="info" v-on:click="doOpenRowDetail(props.row.uuid)" title="Details"><i class="fa fa-info text-white"/></b-btn> -->
          <b-button size="sm" class="btn-rounded" variant="info" :href="'/#/request/'+props.row.uuid" title="Details"><i class="fa fa-info text-white"/></b-button>
        </div>
      </template>

      <template slot="actionButtonsBookingTenant3" slot-scope="props">
        <div class="nowrap">
          <!-- <b-btn size="sm" class="btn-rounded" variant="info" v-on:click="doOpenRowDetail(props.row.uuid)" title="Details"><i class="fa fa-info text-white"/></b-btn> -->
          <b-button size="sm" class="btn-rounded" variant="info" :href="'/#/facility-booking/'+props.row.uuid" title="Details"><i class="fa fa-info text-white"/></b-button>
        </div>
      </template>

      <template slot="actionDetailComplaint" slot-scope="props">
        <div class="nowrap">
          <!-- <b-btn size="sm" class="btn-rounded" variant="info" v-on:click="doOpenRowDetail(props.row.uuid)" title="Details"><i class="fa fa-info text-white"/></b-btn> -->
          <b-button size="sm" class="btn-rounded" variant="info" :href="'/#/reports/complaint-resolved/' + props.row.uuid" title="Details"><i class="fa fa-info text-white"/></b-button>
        </div>
      </template>

      <template slot="actionButtons_bc" slot-scope="props">
        <div class="nowrap text-center">
          <b-button size="sm" class="btn-rounded" variant="info" :href="getUrlDetail(props.row.uuid)" title="Details"><i class="fa fa-info text-white"/></b-button>
          <b-button v-if="!props.row.isPublished" size="sm" class="btn-rounded" variant="primary" :href="getUrlDetail(props.row.uuid) + '/edit'" title="Edit"><i class="fa fa-pencil"/></b-button>
          <b-button v-if="!props.row.isPublished" size="sm" class="btn-rounded" variant="danger" @click="doRemove(props.row.uuid)" title="Remove"><i class="fa fa-times"/></b-button>
        </div>
      </template>

      <!-- FOR: Security-Checking -->
      <template slot="actionButtons_scr" slot-scope="props">
        <div class="nowrap text-center">
          <b-button size="sm" class="btn-rounded" variant="info" :href="'#/security-checking/' + props.row.uuid" title="Details"><i class="fa fa-info text-white"/></b-button>
        </div>
      </template>

      <!-- FOR: Security-Checking-Set-Complate -->
      <template slot="actionButtons_setComplete" slot-scope="props">
        <div class="nowrap text-center">
          <b-button v-if="props.row.securityCheckingStatus !== 'Completed'" size="sm" class="btn-rounded" variant="success" @click="method_3(props.row)" title="Set Completed"><i class="fa fa-check text-white"/></b-button>
        </div>
      </template>

      <!-- FOR: Security-Checking-Not-Complete-Report -->
      <template slot="actionButtons_scncr" slot-scope="props">
        <div class="nowrap text-center">
          <b-button size="sm" class="btn-rounded" variant="info" :href="'#/reports/security-checking-not-complate/' + props.row.uuid" title="Details"><i class="fa fa-info text-white"/></b-button>
        </div>
      </template>

      <!-- FOR: Security-Checking-Overtime -->
      <template slot="actionButtons_sco" slot-scope="props">
        <div class="nowrap text-center">
          <b-button size="sm" class="btn-rounded" variant="info" :href="'#/reports/security-checking-overtime/' + props.row.uuid" title="Details"><i class="fa fa-info text-white"/></b-button>
        </div>
      </template>

      <template slot="securityCheckingStatus" slot-scope="props">
        <div class="">
          <b-badge v-bind:variant="method_1(props.row.securityCheckingStatus)">{{props.row.securityCheckingStatus}}</b-badge>
        </div>
      </template>

      <template slot="taskStatus" slot-scope="props">
        <div class="">
          <b-badge v-bind:variant="method_1(props.row.taskStatus)">{{props.row.taskStatus}}</b-badge>
        </div>
      </template>

      <template slot="highlight" slot-scope="props">
        <div class="text-center">
          <b-badge v-bind:variant="method_3(props.row.timeSpentMinutes, props.row.securityCheckSeries.cycle)"></b-badge>
        </div>
      </template>

      <!-- FOR: Panic Alerts -->
      <template slot="panicAlertStatus" slot-scope="props">
        <div class="text-center">
          <b-badge v-bind:variant="method_1(props.row.panicAlertStatus)">{{props.row.panicAlertStatus}}</b-badge>
        </div>
      </template>

      <!-- FOR: Retributions -->
      <template slot="retributionStatus" slot-scope="props">
        <div class="text-center">
          <b-badge v-bind:variant="method_1(props.row.retributionStatus)">{{props.row.retributionStatus}}</b-badge>
        </div>
      </template>

      <!-- FOR: isCheckingRequired -->
      <template slot="isCheckingRequired" slot-scope="props">
        <div v-if="props.row.isCheckingRequired === true">
          <b-badge class="badge badge-pill badge-success">Yes</b-badge>
        </div>
        <div v-else-if="props.row.isCheckingRequired === false">
          <b-badge class="badge badge-pill badge-danger">No</b-badge>
        </div>
      </template>

      <!-- FOR: Panic Alerts -->
      <template slot="isCheckingRequired" slot-scope="props">
        <div v-if="props.row.isCheckingRequired === true">
          <b-badge class="badge badge-pill badge-success">Yes</b-badge>
        </div>
        <div v-else-if="props.row.isCheckingRequired === false">
          <b-badge class="badge badge-pill badge-danger">No</b-badge>
        </div>
      </template>

      <template slot="isAvailable" slot-scope="props">
        <div v-if="props.row.isAvailable === 1">
          <b-badge class="badge badge-pill badge-success">Yes</b-badge>
        </div>
        <div v-else-if="props.row.isAvailable === 0">
          <b-badge class="badge badge-pill badge-danger">No</b-badge>
        </div>
      </template>

      <!-- FOR: Book-Management/facility && QRCode-Management -->
      <template slot="isAvailableOnHoliday" slot-scope="props">
        <div class="text-center">
          <b-badge :variant="(props.row.isAvailableOnHoliday ? 'primary' : 'secondary')" >{{(props.row.isAvailableOnHoliday ? 'Available' : 'Unavailable')}}</b-badge>
        </div>
      </template>

      <!-- FOR: Book-Management/facility-booking -->
      <template slot="facilityBookingStatus" slot-scope="props">
        <div>
          <b-badge :variant="method_1(props.row.facilityBookingStatus)" >{{ props.row.facilityBookingStatus }}</b-badge>
          <template v-if="props.row.facilityBookingStatus === 'Requested'">
            <b-btn variant="link" size="sm" :id="'popover-' + props.row.uuid.substring(0, 8)">
              <i class="fa fa-chevron-down"></i>
            </b-btn>
            <b-popover
                  :target="'popover-' + props.row.uuid.substring(0, 8)"
                  placement="bottomleft"
                  title="Approval Booking"
                  triggers="focus">
              <b-button size="sm" variant="danger" class="btn-pill" @click="method_3(props.row)"><i class="fa fa-times-circle"></i> Reject</b-button>
              <b-button size="sm" variant="success" class="btn-pill" @click="method_2(props.row, 'Approved')"><i class="fa fa-check-circle"></i> Accept</b-button>
            </b-popover>
          </template>
        </div>
      </template>

      <!-- FOR: Book-Management/request -->
      <template slot="requestStatus" slot-scope="props">
        <div>
          <b-badge :variant="method_1(props.row.requestStatus)" >{{ props.row.requestStatus }}</b-badge>
          <template v-if="props.row.requestStatus === 'Pending'">
            <b-btn variant="link" size="sm" :id="'popover-' + props.row.uuid.substring(0, 8)">
              <i class="fa fa-chevron-down"></i>
            </b-btn>
            <b-popover
                  :target="'popover-' + props.row.uuid.substring(0, 8)"
                  placement="bottomleft"
                  title="Approval Request"
                  triggers="focus">
              <b-button size="sm" variant="success" class="btn-pill" @click="method_2(props.row, 'In Progress')"><i class="fa fa-check-circle"></i> Accept</b-button>
            </b-popover>
          </template>
        </div>
      </template>

      <template slot="isActiveStatusHistory" slot-scope="props">
        <b-badge :variant="props.row.isActive == 1 ? 'success' : 'secondary'">{{props.row.isActive == 1 ? 'Activated' : 'Deactivated'}}</b-badge>
      </template>

      <!-- FOR: Security Checking Schedule -->
      <template slot="isActive" slot-scope="props">
        <div v-if="props.row.isActive === true">
          <b-badge class="badge badge-pill badge-success">Yes</b-badge>
        </div>
        <div v-else-if="props.row.isActive === false">
          <b-badge class="badge badge-pill badge-danger">No</b-badge>
        </div>
      </template>

      <!-- FOR: User-Management & Tenant-Management & Registered Payment Method Account -->
      <template slot="isActive" slot-scope="props">
        <span @click.prevent="method_1(props.row)">
          <toggle-button :value="props.row.isActive == 1" :color="`#3E975D`" :width=60 :sync="true" :labels="{checked: 'Active', unchecked: 'Non Active'}"/>
        </span>
      </template>
      <!-- <template slot="role" slot-scope="props">
        <div class="text-center">
          <b-badge v-bind:variant="method_2(props.row.role)">{{props.row.role}}</b-badge>
        </div>
      </template> -->

      <!-- FOR: Visitor-Management -->
      <template slot="visitorStatus" slot-scope="props">
        <div class="text-center">
          <b-badge v-bind:variant="method_1(props.row.visitorStatus)">{{props.row.visitorStatus}}</b-badge>
        </div>
      </template>
      <template slot="typeText" slot-scope="props">
        <div class="text-center">
          <b-badge v-bind:variant="method_2(props.row.visitorType)">{{props.row.visitorType}}</b-badge>
        </div>
      </template>

      <!-- <template slot="isCheckingRequired" slot-scope="props">
        <div class="text-center">
          <b-badge v-bind:variant="props.row.isCheckingRequired == 1 ? 'primary' : 'secondary'">{{props.row.isCheckingRequired == 1 ? 'Yes' : 'No'}}</b-badge>
        </div>
      </template>
      <div slot="child_row" slot-scope="props">
        <b-form-row>
          <b-col md="6">
            <b-form-group
                  label="Vehicle"
                  label-for="vehicle"
                  label-class="font-weight-bold"
                  :label-cols="2"
                  :horizontal="true">
              <label class="top-padding-6">
                {{props.row.vehicleType + ' ' + props.row.vehiclePlateNumber + ' ' + props.row.vehicleColor}}
              </label>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
                  label="Purpose"
                  label-for="purpose"
                  label-class="font-weight-bold"
                  :label-cols="2"
                  :horizontal="true">
              <label class="top-padding-6">{{props.row.purpose}}</label>
            </b-form-group>
          </b-col>
        </b-form-row>
      </div> -->

      <!-- FOR: Complain-Management -->
      <template slot="complainStatus" slot-scope="props">
        <div class="text-center">
          <b-badge v-bind:variant="method_1(props.row.complainStatus)">{{props.row.complainStatus}}</b-badge>
        </div>
      </template>

      <!-- FOR: Broadcast Message-Management -->
      <template slot="isPublished" slot-scope="props">
        <div class="text-center">
          <b-badge v-bind:variant="method_1(props.row.isPublished)">{{props.row.isPublished ? 'Published' : 'Draft'}}</b-badge>
        </div>
      </template>

      <!-- FOR: Billing Info -->
      <template slot="h__billingFlag">
        <i class="fa fa-flag text-dark" style="font-size:15px"/>
      </template>

      <!-- FOR: Visitors -->
      <template slot="h__walkInGuest">
        <i class="fa fa-users text-dark " title="Walk In Guest" style="font-size:15px"/>
      </template>

      <template slot="walkInGuest" slot-scope="props">
        <i v-if="props.row.visitorFlag === 'Walk In'" class="fa fa-check text-success" aria-hidden="true" title="Walk In Guest"/>
      </template>

      <!-- FOR: Request Charge -->
      <template slot="h__paymentMethod">
        <b>Payment <br>Method</b>
      </template>

      <template slot="h__billingMultiPaymentChecbox">
        <i @click="toggleCheckbox('make-payment-now', 'paymentIds')" class="fa fa-credit-card text-dark" style="cursor: pointer; font-size:15px"/>
      </template>

      <template slot="billingMultiPaymentChecbox" slot-scope="props">
        <div>
          <b-form-checkbox v-if="props.row.billingStatus === 'New'" @change="addIdMultiPayment(props.row.uuid)" button-variant="success" class="make-payment-now" :value="props.row.uuid" aria-describedby="Pay" aria-controls="Pay"></b-form-checkbox>
        </div>
      </template>
      <template slot="billingCycle" slot-scope="props">
        <div class="text-center">
          <b-badge v-bind:variant="method_1(props.row.billingCycle)">{{props.row.billingCycle}}</b-badge>
        </div>
      </template>
      <template slot="billingFlag" slot-scope="props">
        <div class="text-center" v-if="props.row.billingStatus === 'Paid'">
          <b-btn class="flag" :variant="method_2(props.row.billingFlag)" :id="'popover-' + props.row.uuid.substring(0, 8)">&nbsp;</b-btn>
          <b-popover
                :target="'popover-' + props.row.uuid.substring(0, 8)"
                :title="!props.row.billingFlag ? 'Flag this transaction with:' : 'Flagged with:'"
                placement="right"
                triggers="hover focus">
            <b-button v-if="!props.row.billingFlag" size="sm" variant="warning" class="btn-pill" @click="method_4(props.row, 'Dispute')"><i class="fa fa-times"></i> Dispute</b-button>
            <!-- <b-button v-else size="sm" variant="info" class="btn-pill text-white" @click="method_4(props.row, '')"><i class="fa fa-check"></i> Accord</b-button> -->
            <b-badge v-else variant="warning">Dispute</b-badge>
          </b-popover>
        </div>
        <div class="text-center" v-else-if="props.row.billingFlag === 'Overdue'">
          <b-badge
            class="flag"
            v-b-popover.hover="getOverTime(props.row.dueDate)"
            :title="props.row.billingFlag + ' !'"
            :variant="method_2(props.row.billingFlag)">&nbsp;</b-badge>
        </div>
      </template>
      <template slot="billingStatus" slot-scope="props">
        <div class="text-center">
          <b-badge v-bind:variant="method_3(props.row.billingStatus)">{{props.row.billingStatus}}</b-badge>
        </div>
      </template>

      <!-- FOR: Request Charge Status --> 
      <template slot="requestChargeStatus" slot-scope="props">
        <div class="text-center">
          <b-badge v-bind:variant="method_1(props.row.requestChargeStatus)">{{props.row.requestChargeStatus}}</b-badge>
        </div>
      </template>
      

      <template slot="visitorOvertime" slot-scope="props">
        <div class="text-center">
          <b-badge variant="danger">overtime</b-badge>
        </div>
      </template>

      <!-- FOR: Payment Method -->
      <template slot="logo" slot-scope="props">
        <img :src="props.row.paymentMethod.logo" alt="" />
      </template>
      <template slot="paymentUrl" slot-scope="props">
        <div class="nowrap text-center" v-if="props.row.paymentMethod.paymentUrl !== null">
          <router-link :to="props.row.paymentMethod.paymentUrl">Link</router-link>
        </div>
        <div v-else>-</div>
      </template>
      <template slot="namePayment" slot-scope="props">
        {{props.row.paymentMethod.name}}
      </template>

      <!-- FOR: Payment Method -->
      <template slot="logo" slot-scope="props">
        <img :src="props.row.paymentMethod.logo" alt="" />
      </template>
      <template slot="paymentUrl" slot-scope="props">
        <div class="nowrap text-center" v-if="props.row.paymentMethod.paymentUrl !== null">
          <router-link :to="props.row.paymentMethod.paymentUrl">Link</router-link>
        </div>
        <div v-else>-</div>
      </template>
      <template slot="namePayment" slot-scope="props">
        {{props.row.paymentMethod.name}}
      </template>

    </v-server-table>
    <b-button v-bind:class="{ 'show-me': paymentIds.length }" @click="makeMultiplePayment" size="lg" class="multi-payment btn-pill" variant="success"><i class="fa fa-check"></i> Pay</b-button>
    <b-modal ref="makePayment" hide-footer title="Make Multiple Payment">
      <b-form v-on:submit.prevent="doMultiplePayment">
        <b-alert :show="makePaymentDialog.hasError" variant="danger">
          <i class="fa fa-exclamation" aria-hidden="true"></i>{{makePaymentDialog.hasError}}
        </b-alert>
        <b-form-group label="Method" label-for="method" label-class="font-weight-bold" label-cols="3" :horizontal="true">
          <b-form-select v-model="makePaymentDialog.paymentMethod" :options="[
            { value: 'Cash', text: 'Cash' },
            { value: 'Credit Card', text: 'Credit Card' },
            { value: 'Cheque', text: 'Cheque' },
          ]" /><span class="required-input-sign">*</span>
        </b-form-group>
        <b-form-group label="Note" label-for="note" label-class="font-weight-bold" label-cols="3" :horizontal="true">
          <b-form-textarea id="note" v-model="makePaymentDialog.note" placeholder="" :rows="1" :max-rows="6"/><span class="required-input-sign">*</span>
        </b-form-group>
        <b-button type="submit" size="md" variant="success" class="btn-pill pull-right">
          <i v-if="!makePaymentDialog.showLoader" class="fa fa-check"/><i v-else class="fa fa-spinner fa-spin fa-fw"/> Pay Now
        </b-button>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import {ServerTable} from 'vue-tables-2'
import progressLoader from '@/views/components/progressLoader'
import moment from 'moment'

Vue.use(ServerTable)

var responseData = null

let initalConfig = function (adapterName) {
  return {
    filterable: false,
    // filterByColumn: true,
    // filterable: [],
    footerHeadings: false,
    // headings: {},
    // initialPage: 1,
    itemActions: [],
    // orderBy: {column: false},
    // pagination: {
    // chunk: false,
    // dropdown: false
    // nav: ""
    //   edge: true
    // },
    // pagination: false,
    params: {
      ascending: 0,
      order: 'createdAt'
    },
    perPage: 10,
    perPageValues: [],
    // preserveState: true,
    // requestFunction: null,
    // responseAdapter: null,
    // requestKeys: {
    //   limit: 20
    // },
    skin: 'table table-striped',
    sortIcon: { base: 'fa', up: 'fa-chevron-up', down: 'fa-chevron-down', is: 'fa-sort' },
    sortable: [],
    // saveState: true,
    // templates: {},
    // texts: {
    //   count: ''
    // }
    requestFunction: function (data) {
      let customParams = window.setUrlParams(data)
      var self = this
      this.$router.replace({query: customParams})
      return axios.get(this._props.url, { params: customParams })
        .then(response => {
          if (response !== undefined) {
            if (Object.keys(response.data).length) {
              responseData = response.data
              return response
            } else {
              return undefined
            }
          }
        })
        .catch(function (error) {
          self.$store.dispatch('errorMessage', error)
            .then(errMsg => {
              self.$alertify.error(errMsg)
            })
        })
    },
    responseAdapter: function (resp) {
      return {
        data: resp === undefined || resp.length === 0 ? [] : resp.data._embedded[adapterName],
        count: resp === undefined || resp.length === 0 ? 0 : resp.data.total_items
      }
    }
  }
}

export default {
  name: 'cServerTable',
  components: {
    progressLoader
  },
  props: {
    url: '',
    urlRemove: '',
    columns: null,
    options: null,
    method_1: null,
    method_2: null,
    method_3: null,
    method_4: null,
    method_result: null
  },
  data () {
    return {
      ApprovalRejected: [],
      apiUrlBillingStatus: window.AppConfig.apiUrl + 'billing-status',
      apiUrlUpdateBillingStatus: window.AppConfig.apiUrl + 'billing',
      paymentIds: [],
      makePaymentDialog: {
        showLoader: false,
        note: '',
        paymentMethod: 'Cash'
      },
      printInvoice: false,
      paidBillings: []
    }
  },
  created () {
    const url = new URL(window.location.href.replace('/#/', '/'))
    this.options.initialPage = url.searchParams.get('page') !== null ? url.searchParams.get('page') : 1
  },
  beforeMount () {
    const url = new URL(window.location.href.replace('/#/', '/'))
    this.options.initialPage = url.searchParams.get('page') !== null ? url.searchParams.get('page') : 1
  },
  mounted () {
    this.doAutoRefresh()
  },
  beforeDestroy () {
    clearInterval(this.ref)
  },
  methods: {
    setTableDatas () {
      this.$refs.dataTable.refresh()
    },
    setLimit (value) {
      this.$refs.dataTable.setLimit(value)
    },
    setTableConfig (config, adapterName) {
      let opt = {}
      opt.columns = config.columns
      opt.options = initalConfig(adapterName)
      let url = new URL(window.location.href.replace('/#/', '/'))
      opt.options.initialPage = url.searchParams.get('page') !== null ? url.searchParams.get('page') : 1
      Object.keys(config.options).map(function (index) {
        if (index === 'params') {
          opt.options['params'] = {}
          Object.keys(config.options[index]).map(function (param) {
            opt.options.params[param] = window.setDefaultNull(config.options.params[param])
          })
        } else {
          opt.options[index] = config.options[index]
        }
      })
      return opt
    },
    getUrlDetail (uuid) {
      var tmp = this.$route.matched[this.$route.matched.length - 1].path
      if (tmp === '' || tmp.slice(-1) !== '/') tmp += '/'
      return '#' + tmp + uuid
    },
    getOverTime (dueDate) {
      return 'Since ' + moment(dueDate).fromNow()
    },

    doAutoRefresh () {
      this.ref = setInterval(() => {
        this.setTableDatas()
      }, window.AppConfig.IntervalRefreshData)
    },
    doOpenRowDetail (id) {
      this.$refs.dataTable.toggleChildRow(id)
    },
    doRemove (uuid) {
      this.$alertify.confirm(
        'Are you sure want to remove it ?',
        () => {
          axios.delete(
            (this.urlRemove != undefined ? this.urlRemove : this.url) + '/' + uuid // eslint-disable-line
          )
            .then(response => {
              this.$alertify.success('Successfully deleted.')
              this.setTableDatas()
            })
            .catch(error => {
              this.$store.dispatch('errorMessage', error)
                .then(errMsg => {
                  this.$alertify.error(errMsg)
                })
            })
        },
        null
      )
    },

    onTableLoading () {
      this.$refs.progress.activateProgressBar()
      this.$store.dispatch('setIsOffline', false)
    },
    onTableLoaded () {
      this.$refs.progress.deactivateProgressBar()
      if (this.method_result !== undefined) {
        this.method_result(responseData)
      }
    },
    onPagination () {
    },
    addIdMultiPayment (id) {
      let index = this.paymentIds.indexOf(id)
      if (index > -1) {
        this.paymentIds.splice(index, 1)
      } else {
        this.paymentIds.push(id)
      }
    },
    makeMultiplePayment () {
      this.$refs.makePayment.show()
      this.makePaymentDialog.showLoader = false
      this.makePaymentDialog.hasError = false
      this.makePaymentDialog.note = ''
      this.makePaymentDialog.paymentMethod = 'Cash'
    },
    doMultiplePayment () {
      this.makePaymentDialog.showLoader = true
      if (this.makePaymentDialog.note === '') { // eslint-disable-line
        this.$alertify.error('Can\'t Update. Reject Note is Required.')
        this.makePaymentDialog.showLoader = false
      } else {
        let billingUuid = []
        for (let i = 0; i < this.paymentIds.length; i++) {
          billingUuid.push({
            uuid: this.paymentIds[i]
          })
        }
        axios.post(this.apiUrlUpdateBillingStatus, {
          billingUuid: billingUuid,
          note: this.makePaymentDialog.note,
          method: this.makePaymentDialog.paymentMethod // Cash, Credit Card, Cheque
        }).then(response => {
          this.paymentIds = []
          this.$refs.makePayment.hide()
          this.$refs.dataTable.refresh()
          this.$alertify.success('Successfully updated. <br />Status: ' + '<b>' + (this.makePaymentDialog.paymentMethod === 'Cheque' || this.makePaymentDialog.paymentMethod === 'Credit Card' ? 'Pending' : status) + '</b>')
          this.paidBillings = response.data
          this.printInvoice = true
        }).catch(error => {
          window.consoleLog('error')
          this.$refs.makePayment.hide()
          this.$store.dispatch('errorMessage', error).then(errMsg => {
            this.$alertify.error(errMsg)
          })
        })
      }
    },
    toggleCheckbox (className, arrayName) {
      let a = document.querySelectorAll('.make-payment-now .custom-control-input')
      if (this[arrayName].length) {
        this[arrayName] = []
        for (let i = 0; i < a.length; i++) {
          a[i].checked = false
        }
      } else {
        this[arrayName] = []
        for (let i = 0; i < a.length; i++) {
          a[i].checked = true
          this.addIdMultiPayment(a[i].value)
        }
      }
    }
  }
}
</script>

<style scope>
.hide-first-row table th:first-child,
.hide-first-row table td:first-child{
  display:none;
}
.multi-payment {
  position: fixed;
  bottom: 20px;
  /* left: 0; */
  /* z-index: 100004; */
  right: 40px;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease 0s;
  transform: translateY(64px);
}
.multi-payment.show-me {
  transform: translateY(0px);
}
/* .multi-payment:hover {
  transform: translateY(-7px);
} */
.flag {
  border: 1px solid #bbb;
  height: 20px !important;
  border-radius: 20px !important;
  width: 20px !important;
  margin-top: 3px;
  padding: 10px !important;
  display: inline-block !important;
}
.flag.badge-danger {
  border-color: transparent !important;
}
tr.highlight td {
  background: rgba(248, 108, 107, 0.25882352941176473);
}
</style>



// WEBPACK FOOTER //
// src/views/components/cServerTable.vue